// extracted by mini-css-extract-plugin
export default {"Section":"styles_Section__v90P-","Section-inner":"styles_Section-inner__8utMZ"};